import React, { Component } from 'react';
import Utils from '../../utils/Utils';
import { ColoredButton } from '../../packages/components/lib/ColoredButton';
import { Column, Row, cls, HeaderCompound } from '../../packages/components';
import ChannelEventInfo from './components/ChannelEventInfo';
import RecordEvent from './components/RecordEvent';
import ReminderEvent from './components/ReminderEvent';
import TitleSectionEvent from './components/TitleSectionEvent';
import FavoriteEvent from './components/FavoriteEvent';
import LangLiveEvent from './components/LangLiveEvent';
import ResumenEvent from './components/ResumenEvent';
import LangVod from './components/LangVod';
import { connect } from 'react-redux';
import { showToReminderNotification, showToggleFavoritedChannelNotification, showBlockedChannelNotification, showUnBlockedChannelNotification, showReminderRemovedNotification, showRecordingNotification } from '../../actions/notification';
import { setMetricsEvent } from '../../actions/metrics';
import { showModal} from '../../actions/modal';
import { updateLastTouchFavorited, updateLastTouchSeen, setLastTouchReminder } from '../../reducers/user';
import BlockedChannel from './components/BlockedChannel';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import * as EventOptionsUtils from './EventOptionsUtils';
import * as constant from '../../AAFPlayer/constants';
import Device from '../../devices/device';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import store from '../../store';
import { playFullMedia} from '../../actions/playmedia';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import LayersControl from '../../utils/LayersControl';
import EpgConstants from '../../AAF/Nepg/EpgConstants';
import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';




class EventOptions extends Component {
    constructor(props = {}) {
        super(props);
        this.group_id = (this.props && this.props.data && this.props.data.group_id) || null;
        this.channelData = Utils.getChannelInfo(this.group_id);
        this.data = props.data || {};
        this.changeView = false;
        this.options = this.getOptionsModal(this.data);
        this.streamContentType = this.props.streamContentType || null;
        this.streamType = this.props.streamType || null;
        this.domElement = null;
        this.keys = Device.getDevice().getKeys();

        this.state = {
            items: this.options,
        };
    }


    stopPlayer = () =>{
        store.dispatch(playFullMedia({
            ispip: false,
            islive: true,
            src: null,
            playerstate: AAFPLAYER_STOP,
            event: null
        }));
        LayersControl.showUX();
    }


    // OPCIONES DISPONIBLES PARA VOD
    getOptionsGeneralVod = (data) =>{
        const {
            handleClose
        } = this.props;
        const options = [
            {
                item: (
                     <LangVod data ={{...data}} changeLang = {this.props.changeLangCb || null} handleClose = {handleClose} sendMetric={this.sendMetric}/>
                )
            }
        ]
        return options;
    }

    getOptionsGeneralNpvr = (data) =>{
        const {
            handleClose,
        } = this.props;
        const options = [
            {
                item: (
                     <LangLiveEvent
                        onClick={this.changeViewLive}
                        data={{...data}}
                        streamContentType = {this.props.streamContentType}
                        streamType = {this.props.streamType}
                        changeLang = {this.props.changeLangCb}
                        handleClose={handleClose}
                        group_id={this.group_id}
                        keyFrom={this.props && this.props.keyFrom || null}
                        sendMetric = {this.sendMetric}
                    />
                ),
            },
        ];
        return options;
    }

    //OPCIONES DISPONIBLES PARA LIVE
    getOptionsGeneralLive = (data) => {
        const isTPA = ThirdPartyEpgHelper.isThirdPartyApp(data.group_id);
        const {
            setLastTouchReminder,
            showToReminderNotification,
            showToggleFavoritedChannelNotification,
            updateLastTouchFavorited,
            updateLastTouchSeen,
            showBlockedChannelNotification,
            showUnBlockedChannelNotification,
            showModal,
            handleClose,
            showReminderRemovedNotification,
            showRecordingNotification,
            history = null,
            getLinks = null,
            user = {}
        } = this.props;
        const optionTitle = {
            item: !isTPA ? (
                <TitleSectionEvent
                    title={Translator.get('panelOptions_sidemenu_title_program_label','OPCIONES DE PROGRAMA')}
                />
            ) : null
        };
        const options = [
            {
                item: !isTPA ? (
                    <RecordEvent
                        data={{...data}}
                        sendMetric={this.sendMetric}
                        handleClose={handleClose}
                        showRecordingNotification={showRecordingNotification}
                        history={history}
                        stopPlayer = {this.stopPlayer}
                        getLinks = {getLinks}
                    />
                ) : null
            },
            {
                item: !isTPA ? (
                    <ReminderEvent
                        showReminderRemovedNotification={showReminderRemovedNotification}
                        setLastTouchReminder={setLastTouchReminder}
                        sendMetric={this.sendMetric}
                        user ={user}
                        data={{...data}}
                        showToReminderNotification={showToReminderNotification}
                        handleClose={handleClose}
                    />
                ) : null
            },
            {
                item: <TitleSectionEvent title={Translator.get('panelOptions_sidemenu_title_channel_label','OPCIONES DE CANAL')} />,
            },
            {
                item: <FavoriteEvent
                        data={{...data}}
                        handleClose={handleClose || null}
                        showToggleFavoritedChannelNotification={showToggleFavoritedChannelNotification}
                        user ={user}
                        updateLastTouchFavorited = {updateLastTouchFavorited}
                        updateLastTouchSeen = {updateLastTouchSeen}
                        history={history}
                        stopPlayer = {this.stopPlayer}
                        getLinks = {getLinks}
                        sendMetric={this.sendMetric}
                      />,
            },
            {
                item: !isTPA ? (
                     <LangLiveEvent
                        onClick={this.changeViewLive}
                        data={{...data}}
                        streamContentType = {this.props.streamContentType}
                        streamType = {this.props.streamType}
                        changeLang = {this.props.changeLangCb}
                        handleClose={handleClose}
                        group_id={this.group_id}
                        keyFrom={this.props && this.props.keyFrom || null}
                        sendMetric={this.sendMetric}
                    />
                ) : null,
            },
            {
                item: <BlockedChannel
                        channelData={this.channelData}
                        stopPlayer={this.stopPlayer}
                        sendMetric={this.sendMetric}
                        showModal={showModal}
                        user ={user}
                        data={{...data}}
                        showBlockedChannelNotification={showBlockedChannelNotification}
                        showUnBlockedChannelNotification = {showUnBlockedChannelNotification}
                        handleClose={handleClose}/>
            },
        ];
        if(EventOptionsUtils.hasEventOptions({...data}, user)){
            options.unshift(optionTitle);
        }
        return options;
    };

    goBack = () => {
        const {onClose= () =>{}} = this.props;
        if(this.props && this.props.keyFrom && this.props.keyFrom === 'SUB_AUD'){
            this.props && (typeof this.props.handleClose === 'function') && this.props.handleClose(null, onClose);
            return;
        }
        if (this.changeView) {
            // REGRESAMOS AL PADRE
            this.setState({ items: this.options }, () => {
                this.changeView = false;
                window.SpatialNavigation.focus('.event_option_button_section');
            });
        } else {
            this.props && (typeof this.props.handleClose === 'function') && this.props.handleClose(null, onClose);
            if(this.props && this.props.from && this.props.from === EpgConstants.FROM_FULL_EPG){
                // SI SE ABRE MODAL DE OPCIONES DESDE FULL EPG Y SE DA CLIC AMARILLO, REGRESA A LA FULL
                (typeof this.props.showFullEpg === 'function') && this.props.showFullEpg();
            }
        }
    };

    changeViewLive = (items, withouFocus =  true) => {
        this.setState({ items }, () => {
            this.changeView = true;
            withouFocus && window.SpatialNavigation.focus('.event_option_button_section');
        });
    };

    getOptionsModal = () => {
        let options = null;
        // VALIDAR COMO SE MANEJARA LIVE, VOD, CATCHUP, ETC.
        const {streamContentType = ''} = this.props;
        switch(streamContentType){
            case constant.AAF_CONTENT_IS_VOD:
                options = this.getOptionsGeneralVod(this.data);
                break;
            case constant.AAF_CONTENT_IS_NPVR:
                options = this.getOptionsGeneralNpvr(this.data);
                break;
            default:
               options = this.getOptionsGeneralLive({...this.data});

        }
        return options;
    };

    sendDimension = () => {
        const { setMetricsEvent = ()=> {} } = this.props;
        const payload = new AnalyticsDimensionSingleton().getPayload();
        store.dispatch(setMetricsEvent(payload));
        store.dispatch(setMetricsEvent({ type: 'executor' }));
    }

    sendMetric = (label, action = null, category = null) => {
        const { setMetricsEvent = ()=> {} } = this.props;
        store.dispatch(setMetricsEvent({
            hitType: 'event',
            eventCategory: category || 'guia de programacion',
            eventAction: action || `opciones del programa`,
            eventLabel: label
        }));
        store.dispatch(setMetricsEvent({ type: 'executor' }));
        this.sendDimension();
    }

    componentDidMount() {
        window.SpatialNavigation.focus('.event_option_button_section');
        this.addListeners();
    }

    componentWillUnmount = () =>{
        this.removeListeners();
    }



    addListeners = () => {
        const parent = document.getElementsByClassName(`aaf-main-modal-options-col-right-scroll`);
        if(parent && parent[0]){
            this.domElement = parent[0];
            this.domElement && this.domElement.addEventListener('sn:focused', this.hasFocused);
        }
        document && document.addEventListener('keydown', this.handleKey, true);
    }
    removeListeners = () => {
        this.domElement && this.domElement.removeEventListener('sn:focused', this.hasFocused);
        document && document.removeEventListener('keydown', this.handleKey, true);
    }

    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'YELLOW':
                e.preventDefault();
                e.stopPropagation();
                this.goBack();
            break;
            default:
        }
    }



    hasFocused(e) {
        if(e.detail && e.detail.direction && (e.detail.direction==='down' || e.detail.direction==='up')){
            if(e.target && e.target.classList && e.target.classList.contains('event_option_button_section')){
                var element=e.target;
                element.scrollIntoView(false);
            }
        }
    }

    render() {
        const { items } = this.state;
        return (
            <Row className={cls(`aaf-main-modal-options-row`)}>
                <Column lg={8} className={cls(`aaf-main-modal-options-col-left`)}>
                    <Column lg={12} className={cls(`aaf-main-modal-options-col-colors`)}>
                        <ColoredButton
                            color={'yellow'}
                            className={cls(`aaf-main-modal-options-color`, `focusable`, 'modal-options-event-button-yellow')}
                            onClick={this.goBack}
                            imgSrc = {Asset.get('top_head_option_back', '')}>
                            {Translator.get('top_head_option_button_return','REGRESAR')}
                        </ColoredButton>
                    </Column>
                    <ResumenEvent event={this.data} streamContentType={this.streamContentType}/>
                </Column>
                <Column lg={4} className={cls(`aaf-main-modal-options-col-right`)}>
                    {<ChannelEventInfo channelData={this.channelData} />}
                    {
                    <Column className={cls(`aaf-main-modal-options-col-right-scroll`)}>
                        {items &&
                        Array.isArray(items) &&
                        items.map((option) => {
                            if (option && option.item) {
                                return option.item;
                            }
                        })}
                    </Column>
                    }

                </Column>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = {
    showModal,
    showBlockedChannelNotification,
    showUnBlockedChannelNotification,
    showToReminderNotification,
    showToggleFavoritedChannelNotification,
    setMetricsEvent,
    updateLastTouchFavorited,
    updateLastTouchSeen,
    setLastTouchReminder,
    showReminderRemovedNotification,
    showRecordingNotification,
}

export default connect(mapStateToProps, mapDispatchToProps)(EventOptions);



// WEBPACK FOOTER //
// ./src/components/EventOptions/index.jsx